module.exports = __webpack_public_path__ + "static/media/45_bronze_satin_metal_seamless.ea76dc01.jpg";